"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMultibyte = void 0;
const assertString_1 = require("./util/assertString");
/* eslint-disable no-control-regex */
const multibyte = /[^\x00-\x7F]/;
/* eslint-enable no-control-regex */
function isMultibyte(str) {
    (0, assertString_1.assertString)(str);
    return multibyte.test(str);
}
exports.isMultibyte = isMultibyte;
